import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { convert } from "html-to-text";
import Link from "next/link";

const sanitizeHtml = (html) => {
  return convert(html, {
    wordwrap: 130,
    selectors: [{ selector: "img", format: "skip" }],
  });
};

function replaceSpacesWithHyphens(text) {
  return text.replace(/\s+/g, '-');
}

const RelatedGlossary = ({ additionalGlossaries }) => {
  return (
    <Accordion defaultActiveKey="0" className="mt-3" flush>
      {additionalGlossaries.length > 0 ? (
        additionalGlossaries.map((glossary, index) => (
          <Accordion.Item
            eventKey={index.toString()}
            key={glossary._id}
            className="accordion-item"
          >
            <Accordion.Header className="header">
              {glossary.title}
            </Accordion.Header>
            <Accordion.Body className="accordion-item-body">
              <div className="truncate-lines">
                {sanitizeHtml(glossary.description)}
              </div>
              <Link
                href={`/glossary-details/${replaceSpacesWithHyphens(
                  glossary.title
                )}`}
                className="mt-3 d-flex text-white text-decoration-none small fw-semibold textGradient"
              >
                Read more
              </Link>
            </Accordion.Body>
          </Accordion.Item>
        ))
      ) : (
        <p>No related glossaries available.</p>
      )}
    </Accordion>
  );
};

export default RelatedGlossary;
